import { render } from "./OAuthManagement.vue?vue&type=template&id=5d445085"
import script from "./OAuthManagement.vue?vue&type=script&lang=js"
export * from "./OAuthManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__